const allSyncedSections = [
  {
    id: 1,
    name: "My first syncd block",
    definition: {
      tagName: "mj-section",
      attributes: {
        "full-width": false,
        padding: "18px 26px 18px 26px",
        "mj-class": "section",
        "background-color": "#000000",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "O1UdHaHnL",
              tagName: "mj-spacer",
              attributes: {
                height: "30.390625px",
                containerWidth: 198,
              },
            },
          ],
          uid: "HJQ8ytZzW",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "BT5BlMvznB",
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                padding: "0px 0px 0px 0px",
                "fluid-on-mobile": "false",
                alt: "",
                href: "",
                containerWidth: 198,
                width: 137,
              },
            },
          ],
          uid: "CZCiVMqJr",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "14Oa7Un_T",
              tagName: "mj-social",
              attributes: {
                padding: "8px 0px 8px 0px",
                "text-mode": "false",
                "icon-size": "20px",
                align: "right",
                containerWidth: 198,
                "icon-padding": "0px",
              },
              children: [
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                    name: "facebook-noshare",
                    alt: "Facebook",
                    href: "https://www.facebook.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                    alt: "Instagram",
                    name: "instagram",
                    href: "https://www.instagram.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                    name: "linkedin-noshare",
                    alt: "LinkedIn",
                    href: "https://www.linkedin.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
              ],
              style: "roundedwhite",
            },
          ],
          uid: "vcQe-KL02u",
        },
      ],
      layout: 1,
      backgroundColor: null,
      backgroundImage: null,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      uid: "P2fM6_fcp",
    },
    created_at: "2024-01-15T14:48:00.000Z",
    type: "synced_section",
  },
  {
    id: 2,
    name: "Synced složka",
    created_at: "2024-01-25T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 3,
    name: "složka ve složce",
    created_at: "2024-01-25T14:48:00.000Z",
    type: "folder",
    folder_id: 2,
  },
  {
    id: 4,
    name: "My second",
    definition: {
      tagName: "mj-section",
      attributes: {
        "full-width": false,
        padding: "18px 26px 18px 26px",
        "mj-class": "section",
        "background-color": "#000000",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "O1UdHaHnL",
              tagName: "mj-spacer",
              attributes: {
                height: "30.390625px",
                containerWidth: 198,
              },
            },
          ],
          uid: "HJQ8ytZzW",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "BT5BlMvznB",
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                padding: "0px 0px 0px 0px",
                "fluid-on-mobile": "false",
                alt: "",
                href: "",
                containerWidth: 198,
                width: 137,
              },
            },
          ],
          uid: "CZCiVMqJr",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "14Oa7Un_T",
              tagName: "mj-social",
              attributes: {
                padding: "8px 0px 8px 0px",
                "text-mode": "false",
                "icon-size": "20px",
                align: "right",
                containerWidth: 198,
                "icon-padding": "0px",
              },
              children: [
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                    name: "facebook-noshare",
                    alt: "Facebook",
                    href: "https://www.facebook.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                    alt: "Instagram",
                    name: "instagram",
                    href: "https://www.instagram.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                    name: "linkedin-noshare",
                    alt: "LinkedIn",
                    href: "https://www.linkedin.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
              ],
              style: "roundedwhite",
            },
          ],
          uid: "vcQe-KL02u",
        },
      ],
      layout: 1,
      backgroundColor: null,
      backgroundImage: null,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      uid: "P2fM6_fcp",
    },
    created_at: "2023-11-15T14:48:00.000Z",
    type: "synced_section",
  },
  {
    id: 5,
    name: "whatever",
    definition: {
      tagName: "mj-section",
      attributes: {
        "full-width": false,
        padding: "18px 26px 18px 26px",
        "mj-class": "section",
        "background-color": "#000000",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "O1UdHaHnL",
              tagName: "mj-spacer",
              attributes: {
                height: "30.390625px",
                containerWidth: 198,
              },
            },
          ],
          uid: "HJQ8ytZzW",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "BT5BlMvznB",
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                padding: "0px 0px 0px 0px",
                "fluid-on-mobile": "false",
                alt: "",
                href: "",
                containerWidth: 198,
                width: 137,
              },
            },
          ],
          uid: "CZCiVMqJr",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "14Oa7Un_T",
              tagName: "mj-social",
              attributes: {
                padding: "8px 0px 8px 0px",
                "text-mode": "false",
                "icon-size": "20px",
                align: "right",
                containerWidth: 198,
                "icon-padding": "0px",
              },
              children: [
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                    name: "facebook-noshare",
                    alt: "Facebook",
                    href: "https://www.facebook.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                    alt: "Instagram",
                    name: "instagram",
                    href: "https://www.instagram.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                    name: "linkedin-noshare",
                    alt: "LinkedIn",
                    href: "https://www.linkedin.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
              ],
              style: "roundedwhite",
            },
          ],
          uid: "vcQe-KL02u",
        },
      ],
      layout: 1,
      backgroundColor: null,
      backgroundImage: null,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      uid: "P2fM6_fcp",
    },
    created_at: "2023-12-15T14:48:00.000Z",
    type: "synced_section",
  },
  {
    id: 6,
    name: "rename",
    definition: {
      tagName: "mj-section",
      attributes: {
        "full-width": false,
        padding: "18px 26px 18px 26px",
        "mj-class": "section",
        "background-color": "#000000",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "O1UdHaHnL",
              tagName: "mj-spacer",
              attributes: {
                height: "30.390625px",
                containerWidth: 198,
              },
            },
          ],
          uid: "HJQ8ytZzW",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "BT5BlMvznB",
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                padding: "0px 0px 0px 0px",
                "fluid-on-mobile": "false",
                alt: "",
                href: "",
                containerWidth: 198,
                width: 137,
              },
            },
          ],
          uid: "CZCiVMqJr",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "14Oa7Un_T",
              tagName: "mj-social",
              attributes: {
                padding: "8px 0px 8px 0px",
                "text-mode": "false",
                "icon-size": "20px",
                align: "right",
                containerWidth: 198,
                "icon-padding": "0px",
              },
              children: [
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                    name: "facebook-noshare",
                    alt: "Facebook",
                    href: "https://www.facebook.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                    alt: "Instagram",
                    name: "instagram",
                    href: "https://www.instagram.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                    name: "linkedin-noshare",
                    alt: "LinkedIn",
                    href: "https://www.linkedin.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
              ],
              style: "roundedwhite",
            },
          ],
          uid: "vcQe-KL02u",
        },
      ],
      layout: 1,
      backgroundColor: null,
      backgroundImage: null,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      uid: "P2fM6_fcp",
    },
    created_at: "2023-12-15T14:48:00.000Z",
    type: "synced_section",
  },
  {
    // Multilang synced section for testing: carries en/de/cs even when the
    // template it is used in has a different (or empty) language set.
    // NOTE: high id on purpose — createSyncedRow auto-increments from `i = 6`,
    // so ids 7, 8, … are handed out to sections created during tests; a low id
    // here would collide with them.
    id: 300,
    name: "Multilang synced (EN/DE/CS)",
    definition: {
      tagName: "mj-section",
      attributes: {
        "full-width": false,
        padding: "18px 26px 18px 26px",
        "mj-class": "section",
        "background-color": "#ffffff",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "mlText1",
              tagName: "mj-text",
              attributes: {
                align: "left",
                padding: "10px 25px 10px 25px",
                "line-height": 1.5,
                containerWidth: 548,
              },
              content: "Hello from the synced section",
              customKey: null,
            },
            {
              uid: "mlBtn1",
              tagName: "mj-button",
              attributes: {
                align: "center",
                "text-align": "center",
                "background-color": "#000000",
                color: "#ffffff",
                "border-radius": "8px",
                "font-size": "13px",
                padding: "10px 25px 10px 25px",
                "inner-padding": "10px 20px 10px 20px",
                href: "https://example.com/en",
                "font-family": "Helvetica, Arial, sans-serif",
                containerWidth: 548,
                "font-weight": "normal",
                "font-style": "normal",
                "text-transform": "none",
                "text-decoration": "none",
              },
              content: "Read more",
              customKey: null,
            },
          ],
          uid: "mlCol1",
        },
      ],
      layout: 1,
      backgroundColor: null,
      backgroundImage: null,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      uid: "mlSection1",
    },
    translation: {
      en: {
        mlText1: { content: "Hello from the synced section" },
        mlBtn1: {
          content: "Read more",
          attributes: { href: "https://example.com/en" },
        },
      },
      de: {
        mlText1: { content: "Hallo aus der synchronisierten Sektion" },
        mlBtn1: {
          content: "Mehr lesen",
          attributes: { href: "https://example.com/de" },
        },
      },
      cs: {
        mlText1: { content: "Ahoj ze synced sekce" },
        mlBtn1: {
          content: "Číst více",
          attributes: { href: "https://example.com/cs" },
        },
      },
    },
    created_at: "2024-03-15T14:48:00.000Z",
    type: "synced_section",
  },
  {
    id: 111,
    name: "AAA složka",
    created_at: "2024-11-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 112,
    name: "test",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-16T14:48:00.000Z",
    type: "saved_section",
    folder_id: 1,
  },
  {
    id: 113,
    name: "test 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 114,
    name: "Můj blok",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-10T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 115,
    name: "ma folder",
    created_at: "2023-11-18T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 116,
    name: "test a tak",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-25T14:48:00.000Z",
    type: "saved_section",
    folder_id: 1,
  },
  {
    id: 117,
    name: "Jak jako",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-02-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 118,
    name: "Můj blok 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-11T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 119,
    name: "složka",
    created_at: "2023-01-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 210,
    name: "Moje",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-12-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 211,
    name: "Tvoje",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-10T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 212,
    name: "Naše",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-08T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 213,
    name: "Schované",
    created_at: "2023-09-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 214,
    name: "Kraj",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-08-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 215,
    name: "Obec",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-25T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 216,
    name: "MMěsto",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-06T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 217,
    name: "Další schovka",
    created_at: "2023-06-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 218,
    name: "Bože",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-12-25T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 219,
    name: "Nechci",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-02-16T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 220,
    name: "Můj blok 3",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-18T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 221,
    name: "tajné",
    created_at: "2023-12-24T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 222,
    name: "nechci",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-05T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 223,
    name: "Další",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-11-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 224,
    name: "AA první",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-01T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 225,
    name: "složička",
    created_at: "2023-01-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 226,
    name: "test 10",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 227,
    name: "test 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 228,
    name: "Můj blok",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-10T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 229,
    name: "ma folder",
    created_at: "2023-11-15T14:48:00.000Z",
    type: "folder",
  },
  {
    id: 230,
    name: "test",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2023-11-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 231,
    name: "test 2",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-15T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 232,
    name: "Můj blok",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image: "",
    created_at: "2023-01-10T14:48:00.000Z",
    type: "saved_section",
  },
  {
    id: 1,
    name: "My first syncd block",
    definition: {
      tagName: "mj-section",
      attributes: {
        "full-width": false,
        padding: "18px 26px 18px 26px",
        "mj-class": "section",
        "background-color": "#000000",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "O1UdHaHnL",
              tagName: "mj-spacer",
              attributes: {
                height: "30.390625px",
                containerWidth: 198,
              },
            },
          ],
          uid: "HJQ8ytZzW",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "BT5BlMvznB",
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                padding: "0px 0px 0px 0px",
                "fluid-on-mobile": "false",
                alt: "",
                href: "",
                containerWidth: 198,
                width: 137,
              },
            },
          ],
          uid: "CZCiVMqJr",
        },
        {
          tagName: "mj-column",
          attributes: {
            width: "33.333333333333336%",
            "vertical-align": "top",
          },
          children: [
            {
              uid: "14Oa7Un_T",
              tagName: "mj-social",
              attributes: {
                padding: "8px 0px 8px 0px",
                "text-mode": "false",
                "icon-size": "20px",
                align: "right",
                containerWidth: 198,
                "icon-padding": "0px",
              },
              children: [
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                    name: "facebook-noshare",
                    alt: "Facebook",
                    href: "https://www.facebook.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                    alt: "Instagram",
                    name: "instagram",
                    href: "https://www.instagram.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
                {
                  tagName: "mj-social-element",
                  attributes: {
                    src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                    name: "linkedin-noshare",
                    alt: "LinkedIn",
                    href: "https://www.linkedin.com/PROFILE",
                    "background-color": "transparent",
                    show: true,
                  },
                },
              ],
              style: "roundedwhite",
            },
          ],
          uid: "vcQe-KL02u",
        },
      ],
      layout: 1,
      backgroundColor: null,
      backgroundImage: null,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      uid: "P2fM6_fcp",
    },
    created_at: "2024-01-15T14:48:00.000Z",
    type: "synced_section",
    folder_id: 111,
  },
  {
    id: 231,
    name: "test",
    definition: {
      //@ts-expect-error
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "middle",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-spacer",
              attributes: {
                height: "18px",
                containerWidth: 600,
              },
              uid: "S1CHodZMb",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3-eu-west-1.amazonaws.com/uploads/5933fa6ed27a8/1496581226.jpg",
                width: 600,
                padding: "0px 0px 0px 0px",
                containerWidth: 600,
                widthPercent: 100,
              },
              uid: "HkUQv-O4bZ",
            },
            {
              tagName: "mj-divider",
              attributes: {
                "border-color": "#ACACAC",
                "border-style": "solid",
                "border-width": "1px",
                "padding-top": "24px",
                "padding-right": "22px",
                containerWidth: 600,
                color: "#ffffff",
                "padding-bottom": "10px",
                "padding-left": "25px",
                padding: "24px 22px",
              },
              uid: "S1bAC_ZMb",
            },
          ],
          uid: "ByHXPZu4WW",
        },
      ],
      uid: "SkE7vWuNZb",
    },
    image:
      "https://storage.googleapis.com/topolio40002/plugin-assets/6320/40002/IMG_9732.jpg",
    created_at: "2024-01-15T14:48:00.000Z",
    type: "saved_section",
    folder_id: 111,
  },
  {
    // Saved section for testing the hover preview of hidden-on-device content:
    // middle text block has css-class hide_on_desktop, image hide_on_mobile.
    // High id on purpose — createSyncedRow auto-increments from `i = 6`.
    id: 301,
    name: "Hidden on desktop (blok)",
    definition: {
      tagName: "mj-section",
      attributes: {
        "background-color": "#ffffff",
        containerWidth: 600,
        layout: "normal",
        padding: "0px 0px 0px 0px",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "top",
            containerWidth: 600,
          },
          children: [
            {
              tagName: "mj-text",
              attributes: {
                align: "left",
                padding: "10px 25px 10px 25px",
                "line-height": 1.5,
                containerWidth: 600,
              },
              content: "Tenhle text je vidět všude",
              uid: "hidVisTxt1",
            },
            {
              tagName: "mj-text",
              attributes: {
                align: "left",
                padding: "10px 25px 10px 25px",
                "line-height": 1.5,
                containerWidth: 600,
                "css-class": "hide_on_desktop",
              },
              content: "Tenhle text je HIDE ON DESKTOP (jen mobil)",
              uid: "hidDeskTxt1",
            },
            {
              tagName: "mj-image",
              attributes: {
                src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                width: 137,
                padding: "10px 25px 10px 25px",
                containerWidth: 600,
                "css-class": "hide_on_mobile",
              },
              uid: "hidMobImg1",
            },
          ],
          uid: "hidCol1",
        },
      ],
      uid: "hidSection1",
    },
    image: "",
    created_at: "2026-08-20T14:48:00.000Z",
    type: "saved_section",
  },
  {
    // Synced section whose WHOLE section is hidden on desktop
    // (css-class hide_section_on_desktop on the mj-section).
    id: 302,
    name: "Hidden section on desktop (synced)",
    definition: {
      tagName: "mj-section",
      attributes: {
        "full-width": false,
        padding: "18px 26px 18px 26px",
        "mj-class": "section",
        "background-color": "#fff3cd",
        "css-class": "hide_section_on_desktop",
      },
      children: [
        {
          tagName: "mj-column",
          attributes: {
            width: "100%",
            "vertical-align": "top",
          },
          children: [
            {
              tagName: "mj-text",
              attributes: {
                align: "center",
                padding: "10px 25px 10px 25px",
                "line-height": 1.5,
                containerWidth: 548,
              },
              content: "Celá tahle sekce je HIDE ON DESKTOP",
              uid: "hidSecTxt1",
            },
          ],
          uid: "hidSecCol1",
        },
      ],
      layout: 1,
      backgroundColor: null,
      backgroundImage: null,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      uid: "hidSection2",
    },
    created_at: "2026-08-21T14:48:00.000Z",
    type: "synced_section",
  },
];
let i = 6;

export const getAllSyncedSections = ({ request }) => {
  const url = new URL(request.url);
  const sortBy = url.searchParams.get("sort_by");
  const desc = url.searchParams.get("desc");
  // Absent per_page means 15 here, like app.topol.io today, so the e2e suite
  // exercises the editor's fallback walk (see collectAllPages).
  const perPage = Number(url.searchParams.get("per_page")) || 15;
  const page = Number(url.searchParams.get("current_page")) || 1;
  const search = url.searchParams.get("search");
  const folderId = url.searchParams.get("folder_id");
  const type = url.searchParams.get("type");

  let returnSavedBlocks = allSyncedSections;
  if (folderId && folderId !== "") {
    returnSavedBlocks = returnSavedBlocks.filter(
      (item) => item.folder_id === Number(folderId)
    );
  } else {
    returnSavedBlocks = returnSavedBlocks.filter(
      (item) => item.folder_id === undefined
    );
  }

  if (type && type !== "") {
    returnSavedBlocks = returnSavedBlocks.filter(
      (item) => item.type === type || item.type === "folder"
    );
  }

  if (search) {
    returnSavedBlocks = returnSavedBlocks.filter((item) =>
      item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())
    );
  }

  const compareByDate = (a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    if (dateA > dateB) {
      if (desc === "true") return 1;
      return -1;
    } else if (dateA < dateB) {
      if (desc === "true") return -1;
      return 1;
    }
    return 0;
  };
  returnSavedBlocks.sort(compareByDate);

  if (sortBy === "name") {
    const compareByName = (a, b) => {
      if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
        if (desc === "true") return 1;
        return -1;
      }
      if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
        if (desc === "true") return -1;
        return 1;
      }
      return 0;
    };
    returnSavedBlocks.sort(compareByName);
  }

  if (sortBy === "type") {
    const compareByType = (a, b) => {
      if (a.type < b.type) {
        if (desc === "true") return 1;
        return -1;
      }
      if (a.type > b.type) {
        if (desc === "true") return -1;
        return 1;
      }
      return 0;
    };
    returnSavedBlocks.sort(compareByType);
  }

  const result = returnSavedBlocks.slice(perPage * (page - 1), perPage * page);

  const parentFolderId =
    allSyncedSections.find((item) => item.id === Number(folderId))?.folder_id ||
    null;

  return new Response(
    JSON.stringify({
      success: true,
      data: {
        data: result,
        parentFolderId: parentFolderId,
        lastPage: Math.max(1, Math.ceil(returnSavedBlocks.length / perPage)),
      },
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const getOneSyncedRow = ({ params }) => {
  const { rowId } = params;
  const thisRow = allSyncedSections.find((item) => item.id === Number(rowId));

  return new Response(
    JSON.stringify({
      success: true,
      data: thisRow,
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const createSyncedRow = async ({ request }) => {
  const body = await request.json();
  const { definition, img, name, type, folder_id } = body;

  if (type === "folder" && name !== "") {
    i++;
    allSyncedSections.push({
      id: i,
      name: name,
      created_at: new Date(Date.now()).toISOString(),
      type: type,
      ...(folder_id !== undefined ? { folder_id: folder_id } : {}),
    });
  }

  if (type !== "folder" && definition && name !== "") {
    i++;
    allSyncedSections.push({
      id: i,
      name: name,
      definition: definition,
      image: img,
      created_at: new Date(Date.now()).toISOString(),
      type: type,
      ...(folder_id !== undefined ? { folder_id: folder_id } : {}),
    });
  }

  return new Response(
    JSON.stringify({
      success: true,
      data: allSyncedSections.find((item) => item.id === i),
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const editSyncedRow = async ({ request, params }) => {
  const { rowId } = params;
  const body = await request.json();
  const { definition, name, folder_id, translation } = body;
  const thisRow = allSyncedSections.find((item) => item.id === Number(rowId));

  if (!thisRow) {
    return new Response("", {
      status: 400,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  if (folder_id) thisRow.folder_id = folder_id;
  if (definition) thisRow.definition = definition;
  if (translation !== undefined) {
    // Persist the translation so a re-sync serves back every language the
    // synced section was saved with (not just the current template's).
    thisRow.translation = translation;
  }
  if (
    name &&
    name !== "" &&
    !allSyncedSections.find((item) => item.name === name)
  )
    thisRow.name = name;

  return new Response("", {
    status: 200,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteSyncedRow = async ({ request }) => {
  const body = await request.json();
  const { blocksToDelete } = body;
  let error = false;

  blocksToDelete.map((deleteId) => {
    const indexToDelete = allSyncedSections.findIndex(
      (item) => item.id === deleteId
    );
    if (indexToDelete !== -1) {
      allSyncedSections.splice(indexToDelete, 1);
    } else {
      error = true;
    }
  });

  return new Response("", {
    status: !error ? 200 : 400,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
